import './categorizedExpenses.css';

import { useEffect, useState, useMemo } from 'react';

import CategoryIcons from '../../../assets/categoryIcons/categoryIcons';
import TimeLine from '../../timeLine/timeLine';
import SpacerBar from '../../spacerBar/spacerBar';
import VerticalBar from '../../verticalBar/verticalBar';

export default function CategorizedExpenses({loading, expenses, filteredExpenses, filteredCategories}) {

    const [catTime, setCatTime] = useState('0');

    const [catTotal, setCatTotal] = useState(filteredCategories?.[0]?.reduce((sum, current) => sum + current?.expense_amount, 0).toFixed(2));

    const handleTimeChange = (time) => {
        setCatTime(time)
        setCatTotal(filteredCategories?.[time]?.reduce((sum, current) => sum + current?.expense_amount, 0).toFixed(2));
    };

    const loadUpCategory = useMemo(() => {
        setCatTotal(filteredCategories?.[0]?.reduce((sum, current) => sum + current?.expense_amount, 0).toFixed(2))
    }, [filteredCategories, filteredExpenses])

    return (
        <div>
            <div className="categorized-expenses-container">
                <div className="categorized-expenses-header">
                    <p>Expenses by category</p>
                    <TimeLine onTimeChange={handleTimeChange}/>
                </div>
                <SpacerBar/>
                <div className="categorized-expenses-body scroll-container">
                    {filteredCategories[catTime]?.map((item, index) => {
                        return (
                            <div key={index} className="categorized-expenses-list">
                                <div className="categorized-expenses-list-head">
                                    <CategoryIcons indexIcon={item.expense_svg_icon} expenseColor={item.expense_svg_color} className=''/>
                                    <p>{item.expense_name}:</p>
                                    <strong>{Math.round((item.expense_amount / catTotal) * 100) | 0}%</strong>
                                </div>

                                <strong>${parseInt(item.expense_amount)}</strong>
                                
                            </div>
                    )})}
                </div>
            </div>
        </div>
    )
}